import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
  FaChevronRight,
  FaArrowUp,
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const goPageTop = (path) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="hud-footer">
      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-col identity-left">
          <span className="system-tag">SYSTEM_ID: FT_93</span>
          <h2 className="footer-logo">
            FLOWTECH <span className="blue-glow">PUMPS</span>
          </h2>
          <p className="footer-subtext">
            Precision Engineering & Fluid Dynamics.
          </p>

          <div className="welcome-box">
            <span className="welcome-tag">WELCOME TO</span>
            <h4>Industrial & Factory</h4>
            <ul className="footer-bullets">
              <li>Manufacturer of Transformer Oil Pumps</li>
              <li>Established in August 1993</li>
              <li>Brand: FLOWWELL</li>
            </ul>
          </div>
        </div>

        {/* CENTER */}
        <div className="footer-col directory-center">
          <h3 className="section-header">_DIRECTORY</h3>
          <ul className="nav-links">
            {[
              ["/", "HOME"],
              ["/about", "ABOUT US"],
              ["/services", "SERVICES"],
              ["/clients", "CLIENTS"],
              ["/contact", "CONTACT"],
            ].map(([path, label]) => (
              <li key={label}>
                <a onClick={() => goPageTop(path)}>
                  <FaChevronRight className="arrow" /> {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* RIGHT */}
        <div className="footer-col uplink-right">
          {/* <h3 className="section-header">_DATA_UPLINK</h3> */}

          <div className="contact-list">
            <div className="contact-item">
              <FaEnvelope className="blue-icon" />
              <span>info@flowtechpumps.com</span>
            </div>

            <div className="contact-item">
              <FaPhoneAlt className="blue-icon" />
              <span>
                080-2976-1428 <br />
                080-2782-6118
              </span>
            </div>

            <div className="contact-item">
              <FaMapMarkerAlt className="blue-icon" />
              <span>
                No. 186/10, Haragadde Village <br />
                Opp to Sri Chennakeshava Layout, <br />
                Jigani Anekal Main Road, <br />
                Bangalore - 560105
              </span>
            </div>
          </div>

          <div className="social-row">
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaInstagram /></a>
          </div>
        </div>
      </div>

      {/* SCROLL TOP */}
      <div className="ft-top-anchor">
        <button className="ft-top-btn" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      </div>

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">
        © 1993–2026 FLOWTECH PUMPS AND MOTORS | CORE_BY{" "}
        <a href="https://webuniversals.co.in/" className="blue-glow">
          WEBUNIVERSALS
        </a>
      </div>
    </footer>
  );
};

export default Footer;
